import React, { useState } from "react";
import { Formik, Form } from "formik";
import { toast } from "react-toastify";

import "./FlexPackage.css";
import cardcloseicon from "../../../../../../Assets/cardcloseicon.svg";
import { BankTranferDetailsTextInput } from "../../../../../Formik/BankDetailsInput";
import backtick from "../../../../assets/backtick.svg";
import { Util } from "../../../../../../../helpers/util";
import { SuccessModal } from "../../../../../../modals/success-modal/success.modal";
import { $api } from "../../../../../../../helpers/$api";

const FlexPlanTopUp = ({
  balance,
  plan_id,
  setChange,
  paymentData: pd,
  name,
}) => {
  const { currency } = Util.getCurrency();
  const [amount, setAmount] = useState(0);
  const [success, setSuccess] = useState(false);
  const [paymentData] = useState(
    pd || { payment_method: "ovest_wallet", card_id: "" }
  );
  const [submitting, setSubmitting] = useState(false);

  let paymentMethodDetails;

  switch (paymentData.payment_method) {
    case "card": {
      paymentMethodDetails = {
        name: paymentData.meta.name,
        lastFour: paymentData.meta.last_four,
      };
      break;
    }
    case "dollar_wallet": {
      paymentMethodDetails = {
        name: "OVest Dollar Wallet",
        balance: balance.dollar_wallet,
        currency: "$",
      };
      break;
    }
    default:
      paymentMethodDetails = {
        name: "OVest Wallet",
        balance: balance.wallet_balance,
        currency,
      };
  }

  const handleTopupClick = async () => {
    if (submitting) {
      return;
    }
    if (amount < 500) {
      toast.error(`Topup cannot be less than 500`);
      return;
    }
    try {
      const res = await $api.user.topupSavest({
        ...paymentData,
        amount,
        plan_id,
      });

      console.log(res);
      setSuccess(true);
    } catch (error) {
      toast.error(`error topping up - ${error.message}`);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="topup-section">
      <div className="topup-main">
        <div className="topup-header-section">
          <h5 className="topup-header">
            Top Up <span className="plan-topup-name">{name}</span>
          </h5>
          <img src={cardcloseicon} alt="" />
        </div>
        <div>
          <Formik>
            {({ isSubmitting }) => (
              <Form>
                <BankTranferDetailsTextInput
                  name="amount"
                  value={amount}
                  onChange={({ target: { value } }) =>
                    (+value || value === "") && !submitting && setAmount(+value)
                  }
                  type="tel"
                  placeholder="Enter Amount"
                  className="topup-input"
                  style={{
                    width: "100%",
                    flexDirection: "column",
                    marginTop: "2rem",
                  }}
                />
              </Form>
            )}
          </Formik>
        </div>
        <div>
          <div className="silverplan mb-5">
            <p className="fundwith-header">Fund With</p>
            <hr />
            <div className="silverplan-flex">
              <div className="ovest-wallet">
                <div className="investamount">
                  <div
                    style={{
                      border: "1px solid #e2e2e2",
                      padding: "-1px",
                    }}
                  >
                    <p className="paymentmeth-name">
                      {paymentMethodDetails.name}
                    </p>
                    {/* should be render conditionally */}
                    {paymentMethodDetails.currency ? (
                      <p className="paymentmeth-bal">
                        Balance: {paymentMethodDetails.currency}{" "}
                        {Util.formatMoneyNumber(paymentMethodDetails.balance)}
                      </p>
                    ) : (
                      <p> **** {paymentMethodDetails.lastFour}</p>
                    )}
                  </div>

                  <p
                    className="investamount-mini change-balance"
                    onClick={() => setChange(6)}
                  >
                    Change this{" "}
                    <span>
                      <img src={backtick} alt="" className="ml-2" />
                    </span>{" "}
                  </p>
                </div>
                <p className="funds-p mt-5">
                  {/* Insufficient funds. <span onClick={openModal}>Fund wallet</span> */}
                </p>
              </div>
            </div>
          </div>
          <button
            className="top-up-btn"
            onClick={handleTopupClick}
            disabled={submitting}
          >
            Top Up
          </button>
        </div>
      </div>

      <SuccessModal
        url="/dashboard"
        message={`Topup of ${currency}${Util.formatMoneyNumber(
          amount
        )} successful!`}
        show={success}
        onCloseClick={() => (window.location = "/dashboard")}
      />
    </div>
  );
};

export default FlexPlanTopUp;
